// extracted by mini-css-extract-plugin
var _1 = "t2s3";
var _2 = "t2s4";
var _3 = "t2s2";
var _4 = "t2s1";
var _5 = "t2s0";
export { _1 as "button", _2 as "icon", _3 as "link", _4 as "text", _5 as "title" }
